import React from 'react';
import { Paper, Typography } from '@mui/material';

const FormSection = ({ title, children, ...paperProps }) => {
  return (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 3, 
        mb: 4, 
        borderRadius: 2,
        ...paperProps.sx 
      }} 
      {...paperProps}
    >
      {title && (
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
      )}
      {children}
    </Paper>
  );
};

export default FormSection;